import { put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { singleObjectAction, singleObjectActions, singleObjectInitialState } from './SingleObject.duck';
import { TenantService } from '../../../services';
import { newMercureMessage } from './App.duck';

export const actionTypes = {
  ResetData: '[FinancialDocumentTemplate] Reset FinancialDocumentTemplate',
  RequestData: '[FinancialDocumentTemplate] Request FinancialDocumentTemplate',
  FulfilledData: '[FinancialDocumentTemplate] Fulfilled FinancialDocumentTemplate',
};

const initialState = {
  ...singleObjectInitialState,
};

export const reducer = (state = initialState, action) => {
  const newState = singleObjectAction(actionTypes, state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export const actions = {
  ...singleObjectActions(actionTypes),
};

export function* saga() {
  yield takeLatest(actionTypes.RequestData, function* requestFinancialDocumentTemplateSaga(action) {
    const currentTenantId = yield select(state => state.AppReducer.tenant.tenantId);

    const response = yield TenantService.getFinancialDocumentTemplate(currentTenantId, action.itemId);

    yield put(actions.fulfilledData(response.data));
  });

  yield takeEvery(newMercureMessage, function* execute(action) {
    if (typeof action.data['@type'] === 'string' && action.data['@type'] === 'FinancialDocumentTemplate') {
      const { item } = yield select(state => state.FinancialDocumentTemplateReducer);
      if (item && action && action.data.financialDocumentTemplateId === item.financialDocumentTemplateId) {
        yield put(actions.fulfilledData(action.data));
      }
    }
  });
}
